import { render, staticRenderFns } from "./SM-Education-Selectbox.vue?vue&type=template&id=ef09560a"
import script from "./SM-Education-Selectbox.vue?vue&type=script&lang=js"
export * from "./SM-Education-Selectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports